

module.exports = __webpack_require__.stylable.create(
    "TimeIcon3507199888",
    {"classes":{"root":"TimeIcon3507199888__root","TimeIcon":"TimeIcon3507199888__TimeIcon"},"vars":{},"stVars":{"EventTitleColor":"\"fallback(color(--eventTitleColor), color(color-5))\""},"keyframes":{}},
    "",
    1,
    "TimeIcon3507199888",
    null
);
